<template>
  <div class="contact_page">
    <form v-if="thank" @submit.prevent="send" class="row" :class="{'p-3':theme!='showtime'}">
      <div :class="{'col-md-6 col-12 p-r-8':theme=='venue'||theme=='vogue'}" style="width:100%">
        <input
          class="main_outline_color"
          v-model="data.name"
          type="text"
          name="name"
          :placeholder="$t('comment.name')"
        />
      </div>
      <div :class="{'col-md-6 col-12 p-l-8':theme=='venue'||theme=='vogue'}" style="width:100%">
        <input
          class="main_outline_color"
          v-model="data.email"
          type="email"
          name="email"
          :placeholder="$t('comment.email')"
          required
        />
      </div>
      <input
        class="main_outline_color"
        v-model="data.phone"
        type="number"
        name="phone"
        :placeholder="$t('comment.phone-number')"
      />
      <textarea
        class="main_outline_color"
        v-model="data.message"
        :placeholder="$t('comment.message')"
        name="message"
        required
      ></textarea>
      <button
        class="main_button"
        type="submit"
        style="text-transform: uppercase;"
      >{{$t('contact.send')}}</button>
    </form>
    <h5 v-else class="thank_subscribe" style="font-size: 14px;">
      <span class="page_text_font">{{$t('contact.tip')}}</span>
    </h5>
  </div>
</template>

<script>
// import API from "../../API";
export default {
  props: ["theme"],
  data() {
    return {
      data: {
        name: null,
        email: null,
        phone: null,
        message: null
      },
      thank: true
    };
  },
  methods: {
    async send() {
      await this.$axios.post(API.contact_page, this.data);
      this.thank = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.contact_page {
  .p-l-8 {
    padding: 0 0 0 8px;
  }
  .p-r-8 {
    padding: 0 8px 0 0;
  }
  input,
  textarea {
    width: 100%;
    margin-bottom: 15px;
    border-radius: 0;
    padding: 11px;
    color: #1e0909;
    border: 1px solid #e4e4e4;
    font-weight: 400;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  textarea {
    height: 100px;
  }
  button {
    padding: 10px 40px;
    // padding: 0 !important;
    background: unset;
    line-height: 20px;
    background: black;
    color: #fff;
    float: right;
  }

  .thank_subscribe {
    padding: 6px 12px;
    color: #56ad6a;
    background-color: #ecfef0;
    border: 1px solid #56ad6a;
    font-style: normal;
    font-size: 13.5px;
  }
}
@media screen and (max-width: 768px) {
  .contact_page {
    button {
      width: 100%;
    }
    .p-l-8 {
      padding: 0;
    }
    .p-r-8 {
      padding: 0;
    }
  }
}
</style>